import { Component, Input } from '@angular/core';

@Component({
  selector: 'input-module-form',
  templateUrl: './input-module-form.component.html',
  styleUrls: ['./input-module-form.component.scss'],
})
export class InputModuleFormComponent {
@Input() test = 'name not defined';

}
